import PropTypes from 'prop-types';
import React, { memo, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { useLocation } from 'react-router-dom';
import axiosRequest from '../api/api';
import { ActorsConstants } from '../actors/constants/actionTypes';
import { capitalize } from '../mainUtils';
import useURLParams from '../hooks/useURLParams';
import DeleteActorModal from './DeleteActorModal';

function DeleteButton({
  children,
  data,
  disabled,
  onFailure,
  onSuccess,
  targetType = 'actor',
  uuid,
  id,
  maxHeight = true,
}) {
  const [modalVisible, setModalVisible] = useState(false);
  const location = useLocation();

  // console.log('RENDER DELETE', id);

  const showDeleteConfirm = (e) => {
    e.stopPropagation();
    if (disabled) {
      return;
    }

    setModalVisible(true);
  };

  useEffect(() => {
    setModalVisible(false);
  }, [location]);

  return (
    <>
      <div
        onClick={showDeleteConfirm}
        style={{ maxHeight: maxHeight ? 24 : 'auto' }}
      >
        {children}
      </div>
      <DeleteActorModal
        data={data}
        onFailure={onFailure}
        onSuccess={onSuccess}
        targetType={targetType}
        uuid={uuid}
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
      />
    </>
  );
}

export default memo(DeleteButton);

DeleteButton.propTypes = {
  children: PropTypes.node,
  data: PropTypes.object,
  disabled: PropTypes.bool,
  onFailure: PropTypes.func,
  onSuccess: PropTypes.func,
  targetType: PropTypes.string,
  uuid: PropTypes.string,
  maxHeight: PropTypes.bool,
};
